import React, { Component } from 'react'

import { connect } from 'react-redux'

import { changeActiveTab } from 'actions/tabsAction'
import theme from 'components/theme'

import { Container, TabBar, TabContainer, Tab, Indicator, TabPanel, StyledIcon } from './styled'

class Tabs extends Component {
  componentDidMount() {
    const tabToShow = this.props.selectedTab || 0
    this.props.changeActiveTab && this.props.changeActiveTab(this.props.tabs[tabToShow].id)
  }

  static defaultProps = {
    tabs: [],
    onTabClick: null
  }

  onTabClick = tabIndex => {
    this.props.bookingTabs && this.props.changeActiveTab(tabIndex)
    this.props.onTabClick && this.props.onTabClick(tabIndex)
  }

  getCurrentTab = () => {
    const { selectedTab, activeTab, bookingTabs } = this.props

    if (activeTab !== 'undefined' && bookingTabs) {
      return activeTab
    }

    return selectedTab
  }

  render() {
    const { modalState } = this.props
    const modalName = modalState && modalState.length > 0 && modalState[0]
    const isModalReservation = modalName && modalName.reservationModal
    const currentTab = this.getCurrentTab()

    return (
      <Container>
        <TabBar role="tablist">
          {!isModalReservation &&
            (this.props.tabs || []).map(({ id, icon, tab, disabled = false }, index) => (
              <TabContainer key={index} disabled={disabled} bookingTabs={this.props.bookingTabs}>
                <Tab
                  selected={id === currentTab}
                  disabled={disabled}
                  onClick={() => {
                    !disabled && this.onTabClick(id)
                  }}
                  bookingTabs={this.props.bookingTabs}
                  role="tab"
                >
                  <StyledIcon
                    name={icon}
                    color={id === currentTab ? theme.colors.blue : theme.colors.dustyGray}
                    size={30}
                  />
                  {tab}
                </Tab>
                <Indicator selected={id === currentTab} bookingTabs={this.props.bookingTabs} />
              </TabContainer>
            ))}
        </TabBar>
        {this.props.tabs
          .filter(({ id }) => id === currentTab)
          .map(({ panel }, index) => (
            <TabPanel key={index}>{panel}</TabPanel>
          ))}
      </Container>
    )
  }
}

const mapStateToProps = ({ tabs: { activeTab }, modalState }) => ({
  activeTab,
  modalState: modalState.modal ? modalState.modal : modalState
})

const mapDispatchToProps = {
  changeActiveTab
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabs)
